import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const reviewsData = [
  {
    name: 'Giusy Pignatelli',
    rating: 5,
    text: 'Sono stata a cena in questo locale di sabato sera. Una selezione di primi molto buoni e di pizze fatte a regola d\'arte. Ambiente sportivo e dall\'atmosfera informale.',
  },
  {
    name: 'Marco Bianchi',
    rating: 5,
    text: 'Io ho preso la pizza diavola con salame ventricina piccante... una vera chicca! Posto carino e accogliente.',
  },
  {
    name: 'Laura Verdi',
    rating: 5,
    text: 'Ottima esperienza! Il semifreddo alla nocciola è spettacolare. Servizio cordiale e ambiente elegante con un tocco moderno.',
  },
  {
    name: 'Alessandro Russo',
    rating: 4,
    text: 'Cibo delizioso e atmosfera fantastica. La pizza affumicata è da provare assolutamente. Consiglio vivamente!',
  },
  {
    name: 'Sofia Romano',
    rating: 5,
    text: 'Locale meraviglioso con un design Art Deco unico. I piatti sono curati nei minimi dettagli e il personale è molto professionale.',
  },
  {
    name: 'Giovanni Esposito',
    rating: 4,
    text: 'Ottimo ristorante! La carbonara tradizionale è preparata alla perfezione. Tornerò sicuramente!',
  },
];

const Reviews = () => {
  return (
    <section id="recensioni" className="section-padding bg-[#1A1A1A] relative" data-testid="reviews-section">
      <div className="art-deco-pattern" />
      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-[#FFDA00] mb-4 font-semibold">
            Recensioni
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="reviews-title"
          >
            Cosa Dicono di Noi
          </h2>
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="text-[#FFDA00] fill-[#FFDA00]" size={24} />
              ))}
            </div>
            <span className="text-2xl font-bold text-white">4.5</span>
            <span className="text-gray-400">(45 recensioni)</span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviewsData.map((review, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="card"
              data-testid={`review-card-${idx}`}
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 rounded-full bg-[#FFDA00] flex items-center justify-center text-[#222222] font-bold text-xl">
                  {review.name.charAt(0)}
                </div>
                <div className="ml-4">
                  <h4 className="font-bold text-white">{review.name}</h4>
                  <div className="flex">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="text-[#FFDA00] fill-[#FFDA00]" size={14} />
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed">{review.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
